import nfetch from "@/utils/events/nfetch";

export default class CacheService {
    private controllerName = "Cache";

    public limparCacheProdutos(): Promise<Response> {
        return nfetch(`/${this.controllerName}/LimparCacheProdutos`, {
            method: "post",
            credentials: "same-origin",
        });
    }

    public limparCacheProdutosManipulacao(): Promise<Response> {
        return nfetch(`/${this.controllerName}/LimparCacheProdutosManipulacao`, {
            method: "post",
            credentials: "same-origin",
        });
    }
}
